

export const enum EnumPublishConfigRegistry
{
	github = 'https://npm.pkg.github.com',
	npm = 'https://registry.npmjs.org/',
	yarn = 'https://registry.yarnpkg.com',
	taobao = 'http://registry.npm.taobao.org/',
}

